
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, combineLatest, of } from "rxjs";
import { map, switchMap } from 'rxjs/operators'
// import { uniq, flatten } from 'lodash'

@Injectable({
  providedIn: "root"
})

export class CategoryService {

  noAuthHeader = { headers: new HttpHeaders({ "Content-Type": "application/json"}) };

  constructor(
    private http: HttpClient,
    private firestore : AngularFirestore
    ) {}

  //HttpMethods
  joined$: Observable<any>


  //add Category
  addCategory(form) {
    const categoryId = this.firestore.createId();
    form.id = categoryId;
    return this.firestore.collection("categories").doc(categoryId).set(form);
  }
  // addShowroom(form) {
  //   const showroomId = (form.id && form.id!=="") ?   form.id : this.firestore.createId();
  //   form.id = showroomId;
  //     return this.firestore.collection("showrooms").doc(showroomId).set(form);
  //   }
  

  // edit Category
  editCategory(form,id) {
    return this.firestore.collection("categories").doc(id).update(form);
  }

  // get Category list
  getCategoryList(): Observable<any>{
    return this.firestore.collection("categories").snapshotChanges();
  }
  // Delete Category
  deleteCategory(id) {
    return this.firestore.collection("categories").doc(id).delete();
  }

  // Fetch category products
  fetchCategoryProducts(categoryId): Observable<any>{
    return this.firestore.collection("items", ref => ref.where('category_id','==',categoryId)).snapshotChanges();
  }
  
 
}
